export var SurveyActionType;
(function (SurveyActionType) {
    SurveyActionType[SurveyActionType["None"] = 0] = "None";
    SurveyActionType[SurveyActionType["Disqualification"] = 1] = "Disqualification";
    SurveyActionType[SurveyActionType["Flag"] = 2] = "Flag";
    SurveyActionType[SurveyActionType["SkipToEnd"] = 3] = "SkipToEnd";
    SurveyActionType[SurveyActionType["SkipToQuestion"] = 4] = "SkipToQuestion";
    SurveyActionType[SurveyActionType["SkipToSection"] = 5] = "SkipToSection";
    SurveyActionType[SurveyActionType["IncludeSection"] = 6] = "IncludeSection";
    SurveyActionType[SurveyActionType["QuotaOverLimit"] = 7] = "QuotaOverLimit";
    SurveyActionType[SurveyActionType["ExcludeQuestionChoice"] = 8] = "ExcludeQuestionChoice";
    SurveyActionType[SurveyActionType["DisplayQuestionChoice"] = 9] = "DisplayQuestionChoice";
    SurveyActionType[SurveyActionType["HideQuestion"] = 11] = "HideQuestion";
})(SurveyActionType || (SurveyActionType = {}));
export const surveyActionTypeMap = new Map([
    [SurveyActionType.None, { name: 'None' }],
    [SurveyActionType.Disqualification, { name: 'Disqualify' }],
    [SurveyActionType.Flag, { name: 'Flag' }],
    [SurveyActionType.SkipToEnd, { name: 'Skip to end' }],
    [SurveyActionType.SkipToQuestion, { name: 'Skip to question' }],
    [SurveyActionType.SkipToSection, { name: 'Skip to section' }],
    [SurveyActionType.IncludeSection, { name: 'Include section' }],
    [SurveyActionType.QuotaOverLimit, { name: 'Quota over limit' }],
    [SurveyActionType.ExcludeQuestionChoice, { name: 'Hide choice' }],
    [SurveyActionType.DisplayQuestionChoice, { name: 'Display choice' }],
    [SurveyActionType.HideQuestion, { name: 'Hide question' }],
]);
export var SurveyConditionType;
(function (SurveyConditionType) {
    SurveyConditionType[SurveyConditionType["Question"] = 1] = "Question";
    SurveyConditionType[SurveyConditionType["AggregatedSum"] = 2] = "AggregatedSum";
    SurveyConditionType[SurveyConditionType["Classification"] = 3] = "Classification";
})(SurveyConditionType || (SurveyConditionType = {}));
export var SurveyQuestionConditionType;
(function (SurveyQuestionConditionType) {
    SurveyQuestionConditionType["OptionRankedTopX"] = "option-ranked-top-x";
    SurveyQuestionConditionType["OptionSelected"] = "option-selected";
    SurveyQuestionConditionType["OptionNotSelected"] = "option-not-selected";
    SurveyQuestionConditionType["NumberOfOptionsSelected"] = "number-options-selected";
    SurveyQuestionConditionType["OptionRankedFirst"] = "option-ranked-first";
    SurveyQuestionConditionType["OptionRankedLast"] = "option-ranked-last";
    SurveyQuestionConditionType["MatrixValueChosen"] = "matrix-value-chosen";
    SurveyQuestionConditionType["MatrixValueNotChosen"] = "matrix-value-not-chosen";
    SurveyQuestionConditionType["NumberCellValue"] = "number-cell-value";
    SurveyQuestionConditionType["SliderValue"] = "slider-value";
    SurveyQuestionConditionType["SliderValuesTally"] = "slider-values-tally";
    SurveyQuestionConditionType["Straightline"] = "straightline";
})(SurveyQuestionConditionType || (SurveyQuestionConditionType = {}));
const surveyConditionBaseMap = {
    [SurveyQuestionConditionType.OptionRankedTopX]: 'Top X ranked option',
    [SurveyQuestionConditionType.OptionSelected]: 'Option selected',
    [SurveyQuestionConditionType.OptionNotSelected]: 'Option not selected',
    [SurveyQuestionConditionType.NumberOfOptionsSelected]: 'Number of options selected',
    [SurveyQuestionConditionType.OptionRankedFirst]: 'First ranked option',
    [SurveyQuestionConditionType.OptionRankedLast]: 'Last ranked option',
    [SurveyQuestionConditionType.MatrixValueChosen]: 'Selected',
    [SurveyQuestionConditionType.MatrixValueNotChosen]: 'Not selected',
    [SurveyQuestionConditionType.NumberCellValue]: 'Cell value',
    [SurveyQuestionConditionType.SliderValue]: 'Row value',
    [SurveyQuestionConditionType.SliderValuesTally]: 'Row Values Tally',
    [SurveyQuestionConditionType.Straightline]: 'Straightline',
};
export const surveyConditionTypeMap = Object.keys(surveyConditionBaseMap).reduce((acc, key) => {
    const enumKey = key;
    acc.set(enumKey, { name: surveyConditionBaseMap[enumKey] });
    return acc;
}, new Map());
export var SurveySumConditionItemType;
(function (SurveySumConditionItemType) {
    SurveySumConditionItemType["SliderRowValue"] = "slider-row-value";
    SurveySumConditionItemType["NumberTableCellValue"] = "number-table-cell-value";
})(SurveySumConditionItemType || (SurveySumConditionItemType = {}));
export var SurveyPipedValueType;
(function (SurveyPipedValueType) {
    SurveyPipedValueType["OptionsSelected"] = "options-selected";
    SurveyPipedValueType["OptionsNotSelected"] = "options-not-selected";
    SurveyPipedValueType["MatrixRowsSelected"] = "matrix-values-selected";
    SurveyPipedValueType["MatrixRowsNotSelected"] = "matrix-values-not-selected";
    SurveyPipedValueType["MatrixOptionsSelected"] = "matrix-options-selected";
    SurveyPipedValueType["MatrixOptionsNotSelected"] = "matrix-options-not-selected";
    SurveyPipedValueType["FirstRankedOption"] = "first-ranked-option";
    SurveyPipedValueType["SecondRankedOption"] = "second-ranked-option";
    SurveyPipedValueType["SecondLastRankedOption"] = "second-last-ranked-option";
    SurveyPipedValueType["LastRankedOption"] = "last-ranked-option";
    SurveyPipedValueType["AllRankedOptions"] = "all-ranked-options";
    SurveyPipedValueType["RankedXOption"] = "ranked-x-option";
    SurveyPipedValueType["SliderRowValue"] = "slider-row-value";
    SurveyPipedValueType["SliderHighestValue"] = "slider-highest-value";
    SurveyPipedValueType["SliderLowestValue"] = "slider-lowest-value";
    SurveyPipedValueType["NumberTableCellValue"] = "number-cell-value";
    SurveyPipedValueType["TextEntryValues"] = "text-entry-values";
    SurveyPipedValueType["AlternateImageShown"] = "alternate-image-shown";
})(SurveyPipedValueType || (SurveyPipedValueType = {}));
export var SurveyTaggingResultType;
(function (SurveyTaggingResultType) {
    SurveyTaggingResultType[SurveyTaggingResultType["Classification"] = 1] = "Classification";
})(SurveyTaggingResultType || (SurveyTaggingResultType = {}));
export const surveyTaggingResultTypeMap = new Map([
    [SurveyTaggingResultType.Classification, { name: 'Classify as' }],
]);
export var SurveyLogicRule;
(function (SurveyLogicRule) {
    SurveyLogicRule[SurveyLogicRule["AllOfTheAbove"] = 1] = "AllOfTheAbove";
    SurveyLogicRule[SurveyLogicRule["AnyOfTheAbove"] = 2] = "AnyOfTheAbove";
    SurveyLogicRule[SurveyLogicRule["CustomExpression"] = 3] = "CustomExpression";
})(SurveyLogicRule || (SurveyLogicRule = {}));
export const surveyLogicRuleMap = new Map([
    [SurveyLogicRule.AllOfTheAbove, { name: 'All of the above' }],
    [SurveyLogicRule.AnyOfTheAbove, { name: 'Any of the above' }],
    [SurveyLogicRule.CustomExpression, { name: 'Custom expression' }],
]);
